"use strict";

var base = require("base/product/base");
var baseWishlist = require("plugin_wishlists/wishlist/wishlist");

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $(".minicart").trigger("count:update", response);
    var messageType = response.error ? "alert-danger" : "alert-success";
    const isDesktop = $(window).width() > 768;

    if ($(".add-to-cart-messages").length === 0) {
        $("body").append("<div class='add-to-cart-messages'></div>");
    }

    if (!isDesktop || response.error) {
        $(".add-to-cart-messages").append(
            `<div class="${messageType} add-to-basket-alert text-center alert alert-dismissible fade show d-flex align-items-center border-none" role="alert">
                ${response.message}
                <button type="button" class="close p-0 ml-auto position-relative" data-dismiss="alert" aria-label="Close">
                    <span class="d-flex" aria-hidden="true">
                        <svg data-id="icon_close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><rect id="clear_space" width="24" height="24" fill="#fff" opacity="0"/><path id="Icon_ionic-ios-close" data-name="Icon ionic-ios-close" d="M23.243,20.955l6.905-6.907a1.618,1.618,0,0,0-2.288-2.289l-6.905,6.907L14.049,11.76a1.618,1.618,0,1,0-2.288,2.289l6.905,6.907-6.905,6.907a1.618,1.618,0,0,0,2.288,2.289l6.905-6.907,6.905,6.907a1.618,1.618,0,0,0,2.288-2.289Z" transform="translate(-8.618 -8.622)" fill="#fff"/></svg>
                    </span>
                </button>
                </div>`
        );

        setTimeout(function () {
            $(".add-to-basket-alert").remove();
        }, 3000);
    }
}

module.exports = Object.assign({}, baseWishlist, {
    addToCartFromWishlist: function () {
        $("body").on("click", ".add-to-cart", function () {
            var pid;
            var addToCartUrl;
            var pidsQty;

            $("body").trigger("product:beforeAddToCart", this);

            pid = $(this).data("pid");
            addToCartUrl = $(this).data("url");
            pidsQty = parseInt(
                $(this).closest(".product-info").find(".quantity").val(),
                10
            );

            var form = {
                pid: pid,
                quantity: pidsQty
            };

            if ($(this).data("option")) {
                form.options = JSON.stringify($(this).data("option"));
            }

            $(this).trigger("updateAddToCartFormData", form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: "POST",
                    data: form,
                    success: function (data) {
                        if (!data.error) {
                            $("body").trigger("product:afterAddToCart", { data, pid: form.pid, quantity: +form.quantity });
                        }
                        handlePostCartAdd(data);
                        $.spinner().stop();
                        base.miniCartReportingUrl(
                            data.reportingURL,
                            data.error
                        );
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    }
});
